import React from 'react'
import './testimonials.css'
import AVTR1 from '../../assets/avatar1.jpg'
import AVTR2 from '../../assets/avatar2.jpg'
import AVTR3 from '../../assets/avatar3.jpg'
import AVTR4 from '../../assets/avatar4.jpg'

import { Navigation, Pagination } from 'swiper';

import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const Testimonials = () => {

  const data = [
    {
      avatar: AVTR1,
      name: 'Tina Snow',
      review: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Sunt quasi sequi accusamus natus, repudiandae voluptatum voluptates asperiores rem assumenda in doloribus unde libero sit, ut modi molestias expedita quaerat pariatur.'
    },
    {
      avatar: AVTR2,
      name: 'Tina Snow',
      review: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Sunt quasi sequi accusamus natus, repudiandae voluptatum voluptates asperiores rem assumenda in doloribus unde libero sit, ut modi molestias expedita quaerat pariatur.'
    },
    {
      avatar: AVTR3,
      name: 'Tina Snow',
      review: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Sunt quasi sequi accusamus natus, repudiandae voluptatum voluptates asperiores rem assumenda in doloribus unde libero sit, ut modi molestias expedita quaerat pariatur.'
    },
    {
      avatar: AVTR4,
      name: 'Tina Snow',
      review: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Sunt quasi sequi accusamus natus, repudiandae voluptatum voluptates asperiores rem assumenda in doloribus unde libero sit, ut modi molestias expedita quaerat pariatur.'
    },
  ]


  return (
    <section id="testimonials">
      <h5>Review From clients</h5>
      <h2>Testimonials</h2>

      <Swiper className="container testimonials__container"
        modules={[Navigation, Pagination]}
        spaceBetween={40}
        slidesPerView={1}
        navigation
        pagination={{ clickable: true }}
      >
        {
          data.map(({ avatar, name, review, }, index) => {
            return (
              <SwiperSlide key={index} className="testimonial">
                <div className="client__avatar">
                  <img src={avatar} alt={avatar} />
                </div>
                <h5 className='client__name'>{name}</h5>
                <small className='client__review'>{review}</small>
              </SwiperSlide>
            )
          })
        }
      </Swiper>
    </section>
  )
}

export default Testimonials